/**
 * Return the first date of the previous 12 month.
 * It is month-inclusive so for example:
 * when date is 2022-01-01 it should be return 2021-02-01
 * @param date date to be subtracted
 * @returns First date of the input date minus eleven
 */
export function getFirstDateTwelveMonthsAgo(date: Date): Date {
  const currentDate = new Date(date);
  currentDate.setDate(1);
  currentDate.setMonth(currentDate.getMonth() - 11);
  return currentDate;
}
